import "./Input.css";

const Input = ({
  label,
  value,
  handler,
  type,
  error,
  readOnly
}: {
  label: string;
  value: string;
  handler: (text: string) => void;
  type?: `text` | `number` | "tel" | "email";
  error?: string;
  readOnly?: boolean;
}) => {
  return (
    <div className="input_wrapper ">
      <label className="flex med_text">{label}</label>
      <input
        readOnly={!!readOnly}
        value={value}
        onChange={(e) => {
          const value = e.target.value;
          handler(value);
        }}
        type={type ? type : "text"}
        className={`${readOnly ? "noOutline" : ""} input_field`}
      />
      {error ? <span className="errorMsg">{error}</span> : ``}
    </div>
  );
};

export default Input;
